exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-page[data-v-37b86f20]{display:grid;height:100vh;width:100vw;position:relative}", ""]);

// exports
